export default "__VITE_ASSET__k8dK41hB__"